import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import * as i3 from '@angular/common';
import * as i4 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i5 from 'primeng/dropdown';
import * as i6 from 'primeng/inputswitch';
import * as i7 from 'primeng/inputnumber';
import * as i8 from 'primeng/inputtextarea';
import { PrimengLibraryModule } from 'primeng-library';

class CommonQuetionsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.isAutoPopulateTemplate = new BehaviorSubject(false);
    }
    getTaskQuestioneryOnCategory(quesCategory) {
        return this.httpClient.get(`/question/category/${quesCategory}`).pipe(map((response) => response.data));
    }
    getSubTasksType(superTaskType) {
        return this.httpClient.get(`/task/superTask/${superTaskType}/taskTypes`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
}
CommonQuetionsService.ɵfac = function CommonQuetionsService_Factory(t) { return new (t || CommonQuetionsService)(i0.ɵɵinject(i1.HttpClient)); };
CommonQuetionsService.ɵprov = i0.ɵɵdefineInjectable({ token: CommonQuetionsService, factory: CommonQuetionsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonQuetionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function CommonQuestionsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelementStart(2, "label", 9);
    i0.ɵɵtext(3, "Sub - Task type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵelementStart(5, "b");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.subTaskDetails.subTaskTypeCode ? ctx_r0.subTaskDetails.subTaskTypeCode.toLowerCase() : "");
} }
function CommonQuestionsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} }
function CommonQuestionsComponent_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtext(2, " Do you want to duplicate data from previous petition? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵelementStart(4, "mat-slide-toggle", 17);
    i0.ɵɵlistener("change", function CommonQuestionsComponent_div_2_div_8_Template_mat_slide_toggle_change_4_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.isDuplicatedtoggle("duplicated", $event.checked); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CommonQuestionsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "h5", 13);
    i0.ɵɵtext(2, "Choose from the options below");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵtext(5, " Is Petition Filed Outside Imagility ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 16);
    i0.ɵɵelementStart(7, "mat-slide-toggle", 17);
    i0.ɵɵlistener("change", function CommonQuestionsComponent_div_2_Template_mat_slide_toggle_change_7_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.isDuplicatedtoggle("idx", $event.checked); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CommonQuestionsComponent_div_2_div_8_Template, 5, 0, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r2.isDuplicatedData === "true");
} }
function CommonQuestionsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} }
function CommonQuestionsComponent_h5_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 13);
    i0.ɵɵtext(1, "Enter the Sub-Task Details ");
    i0.ɵɵelementEnd();
} }
function CommonQuestionsComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelementStart(2, "label", 21);
    i0.ɵɵtext(3, "Sub-Task Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p-dropdown", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r5.subTaskType);
} }
function CommonQuestionsComponent_div_7_div_1_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "label", 34);
    i0.ɵɵtext(2, "How many?");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-inputNumber", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("min", 1)("max", 99)("maxlength", 2)("useGrouping", false);
} }
function CommonQuestionsComponent_div_7_div_1_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "label", 34);
    i0.ɵɵtext(2, "Explanation");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "textarea", 37);
    i0.ɵɵelementEnd();
} }
function CommonQuestionsComponent_div_7_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, CommonQuestionsComponent_div_7_div_1_div_6_div_1_Template, 4, 4, "div", 31);
    i0.ɵɵtemplate(2, CommonQuestionsComponent_div_7_div_1_div_6_div_2_Template, 4, 0, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r13 = i0.ɵɵnextContext(2).index;
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r13 === 0 || i_r13 > 1 && (ctx_r15.questionList[i_r13] == null ? null : ctx_r15.questionList[i_r13].isAdditionalInfoReq));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r13 === 1 || (ctx_r15.questionList[i_r13] == null ? null : ctx_r15.questionList[i_r13].hasExplanation));
} }
function CommonQuestionsComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵelement(5, "p-inputSwitch", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CommonQuestionsComponent_div_7_div_1_div_6_Template, 3, 2, "div", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    const i_r13 = ctx_r19.index;
    const question_r12 = ctx_r19.$implicit;
    i0.ɵɵproperty("formGroupName", i_r13);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", question_r12.value.question, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", question_r12.value.answer);
} }
function CommonQuestionsComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, CommonQuestionsComponent_div_7_div_1_Template, 7, 3, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r12 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !question_r12.value.conditionalVisibilityAtTask || question_r12.value.conditionalVisibilityAtTask && ((ctx_r6.subTaskDetails == null ? null : ctx_r6.subTaskDetails.taskTypeDetails == null ? null : ctx_r6.subTaskDetails.taskTypeDetails.petitionType) === "NEW" || (ctx_r6.subTaskDetails == null ? null : ctx_r6.subTaskDetails.taskTypeDetails == null ? null : ctx_r6.subTaskDetails.taskTypeDetails.petitionType) === "CAP"));
} }
// import { CreateTaskService } from "../../../../src/app/modules/superTask/components/create-task/create-task.service";
// import { CreateTaskService } from "src/app/modules/superTask/components/create-task/create-task.service";
//   ../../../../src/app/modules/superTask/components/create-task/create-task.service
class CommonQuestionsComponent {
    constructor(fb, apiService, parentFor) {
        this.fb = fb;
        this.apiService = apiService;
        this.parentFor = parentFor;
        this.questionList = [];
        this.getValueAutopopulateTemplate = false;
        this.subTaskDetails = null;
    }
    ngOnInit() {
        this.isDuplicatedData = sessionStorage.getItem('isDuplicated');
        // this.isDuplicatedData = this.createTaskService.getValue();
        // console.log(this.subTaskDetails, "sub task details");
        this.userType = sessionStorage.getItem("userTypeRole");
        this.immigrantType = "VISA";
        this.form = this.parentFor.form;
        this.customQuestions = this.fb.group({
            isOutsideImagility: [false],
            taskTypeCode: [null],
            CommonTaskQuestions: this.fb.array([]),
        });
        // this.customQuestions.get('isOutsideImagility').valueChanges.subscribe(x=>{
        //   console.log("customQuestions value changes",x)
        //   if(this.customQuestions.get('isOutsideImagility').value){
        //     this.customQuestions.controls['isOutsideImagility'].setValidators([Validators.required])
        //   }else{
        //     this.customQuestions.controls['isOutsideImagility'].clearValidators();
        //   }
        //   this.customQuestions.controls['isOutsideImagility'].updateValueAndValidity();
        // })
        /* this.createTaskService.getValue().subscribe(res=>{
          this.getValueAutopopulateTemplate = res;
        )} */
        this.apiService.isAutoPopulateTemplate.subscribe((res) => {
            this.getValueAutopopulateTemplate = res;
            // console.log(res, '########');
        });
        this.form.addControl("customQuestions", this.customQuestions);
        this.getQuestions();
        this.isImmigrant = this.superTaskTypeCode === "IMMPET" ? true : false;
        this.getSubTaskType();
    }
    get getFormQuestionsArray() {
        return this.form.controls["customQuestions"].get("CommonTaskQuestions").controls;
    }
    createQuestionList(item) {
        const savedItem = this.subTaskDetails && this.subTaskDetails.questionAndResponseDTO.find((x) => x.id === item.id || (!item.questionId && x.questionId === item.id));
        return this.fb.group({
            answer: savedItem ? Boolean(savedItem.answer) : (item && item.answer ? item.answer : null),
            id: item && item.response && item.response.id ? item.response.id : null,
            questionId: item && item.id ? item.id : null,
            isBoolean: true,
            additionalInfo: savedItem ? savedItem.additionalInfo : null,
            sequenceNumber: item && item.sequenceNumber ? item.sequenceNumber : null,
            question: item && item.question ? item.question : null,
            conditionalVisibilityAtTask: item && item.conditionalVisibilityAtTask ? item.conditionalVisibilityAtTask : null,
            isAdditionalInfoReq: item && item.isAdditionalInfoReq ? item.isAdditionalInfoReq : null,
            hasExplanation: item && item.hasExplanation ? item.hasExplanation : null
        });
    }
    getQuestions() {
        var _a, _b;
        const visaGroupCode = ["P1A", "P1B"].includes((_b = (_a = this.form.value) === null || _a === void 0 ? void 0 : _a.newTaskForm) === null || _b === void 0 ? void 0 : _b.visaType) ? 'P1VISAQUECTGTYP' : "VISAQUECTGTYP";
        this.apiService
            .getTaskQuestioneryOnCategory(visaGroupCode)
            .pipe(take(1))
            .subscribe((response) => {
            if (response) {
                this.questionList = response ? response.map((item) => {
                    return Object.assign(Object.assign({}, item), { answer: !!(item.answer && item.answer === 1) });
                }) : [];
                this.form.controls["customQuestions"].get("CommonTaskQuestions").clear();
                response.forEach((x) => {
                    // console.log(this.createQuestionList(x));
                    this.form.controls["customQuestions"].get("CommonTaskQuestions").push(this.createQuestionList(x));
                });
            }
        });
    }
    handleSwitchChange() {
        if (this.form.controls["customQuestions"].get("isOutsideImagility").value) {
            this.form.controls["customQuestions"].patchValue({
                taskTypeCode: "PETITION",
            });
        }
    }
    getSubTaskType() {
        this.form.patchValue({
            taskTypeCode: null,
        });
        if (this.superTaskTypeCode || "NONIMMPET") {
            this.apiService
                .getSubTasksType(this.superTaskTypeCode ? this.superTaskTypeCode : "NONIMMPET")
                .subscribe((response) => {
                if (this.userType === "Petitioner" ||
                    (this.form.get("visaType") &&
                        ["TN1", "TN2"].includes(this.form.get("visaType").value))) {
                    response = response.filter((ele) => ele.code !== "RFE");
                }
                this.subTaskType = response;
                if (!this.form.get("customQuestions").get("isOutsideImagility").value) {
                    this.form.patchValue({
                        taskTypeCode: "PETITION",
                    });
                }
            });
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    isDuplicatedtoggle(param, e) {
        // console.log(param, '########', e);
        this.apiService.isAutoPopulateTemplate.next(e);
        if (e) {
            sessionStorage.removeItem('isDuplicated');
        }
    }
}
CommonQuestionsComponent.ɵfac = function CommonQuestionsComponent_Factory(t) { return new (t || CommonQuestionsComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(CommonQuetionsService), i0.ɵɵdirectiveInject(i1$1.FormGroupDirective)); };
CommonQuestionsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CommonQuestionsComponent, selectors: [["common-questions-library"]], inputs: { superTaskTypeCode: "superTaskTypeCode", isExtension: "isExtension", subTaskDetails: "subTaskDetails" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 8, vars: 7, consts: [["class", "p-fluid p-formgrid p-grid", 4, "ngIf"], ["class", "p-grid dashed-line p-my-4 mx-1", 4, "ngIf"], ["class", "", 4, "ngIf"], ["formGroupName", "customQuestions"], ["class", "p-text-bold pl-3", 4, "ngIf"], ["class", "p-fluid p-formgrid p-grid px-3 pt-2 pb-3", 4, "ngIf"], ["formArrayName", "CommonTaskQuestions", 4, "ngFor", "ngForOf"], [1, "p-fluid", "p-formgrid", "p-grid"], [1, "p-col-12"], [1, "label-large-bold"], [1, "sub-task-type-text"], [1, "p-grid", "dashed-line", "p-my-4", "mx-1"], [1, ""], [1, "p-text-bold", "pl-3"], [1, "p-grid", "p-my-2", "px-3"], ["name", "question", 1, "p-col-9"], [1, "p-col-1"], ["name", "", 3, "disabled", "checked", "change"], ["class", "p-grid p-my-2 px-3", 4, "ngIf"], [1, "p-fluid", "p-formgrid", "p-grid", "px-3", "pt-2", "pb-3"], [1, "p-col-4"], ["for", "tasktype", 1, "create-task-label", "mb-0", "required"], ["inputId", "tasktype", "formControlName", "taskTypeCode", "placeholder", "Select Task Type", "optionLabel", "name", "optionValue", "code", 3, "options"], ["formArrayName", "CommonTaskQuestions"], [3, "formGroupName", 4, "ngIf"], [3, "formGroupName"], [1, "p-grid", "p-my-2", "marginLeftQuestion"], [1, "p-col-9"], ["color", "primary", "name", "answer", "formControlName", "answer"], ["class", "p-grid", 4, "ngIf"], [1, "p-grid"], ["class", "marginLeftAnswer p-col-5", 4, "ngIf"], ["class", "marginLeftAnswer p-col-10", 4, "ngIf"], [1, "marginLeftAnswer", "p-col-5"], [1, "create-task-label"], ["styleClass", "create-task-input", "placeholder", "Enter", "formControlName", "additionalInfo", 1, "d-block", 3, "min", "max", "maxlength", "useGrouping"], [1, "marginLeftAnswer", "p-col-10"], ["rows", "3", "formControlName", "additionalInfo", "placeholder", "Enter", "pInputTextarea", "", "autoResize", "autoResize", 1, "create-task-textarea", "d-block"]], template: function CommonQuestionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CommonQuestionsComponent_div_0_Template, 8, 1, "div", 0);
        i0.ɵɵtemplate(1, CommonQuestionsComponent_div_1_Template, 1, 0, "div", 1);
        i0.ɵɵtemplate(2, CommonQuestionsComponent_div_2_Template, 9, 1, "div", 2);
        i0.ɵɵtemplate(3, CommonQuestionsComponent_div_3_Template, 1, 0, "div", 1);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, CommonQuestionsComponent_h5_5_Template, 2, 0, "h5", 4);
        i0.ɵɵtemplate(6, CommonQuestionsComponent_div_6_Template, 5, 1, "div", 5);
        i0.ɵɵtemplate(7, CommonQuestionsComponent_div_7_Template, 2, 1, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.subTaskDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.subTaskDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.subTaskDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.subTaskDetails);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.subTaskDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.form.get("customQuestions").get("isOutsideImagility").value || ctx.isImmigrant);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.getFormQuestionsArray);
    } }, directives: [i3.NgIf, i1$1.NgControlStatusGroup, i1$1.FormGroupName, i3.NgForOf, i4.MatSlideToggle, i5.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i1$1.FormArrayName, i6.InputSwitch, i7.InputNumber, i1$1.MaxLengthValidator, i1$1.DefaultValueAccessor, i8.InputTextarea], styles: ["[_nghost-%COMP%]   .mat-slide-toggle.mat-checked[_ngcontent-%COMP%]    .mat-slide-toggle-bar:after{content:\"Yes\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:4px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]:not(.mat-checked)    .mat-slide-toggle-bar:after{content:\"No\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:21px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]   .mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#30b1e1!important}  .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar,   .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background-color:#30b1e1}.marginLeftQuestion[_ngcontent-%COMP%]{margin-left:2.1rem!important}.marginLeftAnswer[_ngcontent-%COMP%]{margin-left:40px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonQuestionsComponent, [{
        type: Component,
        args: [{
                selector: "common-questions-library",
                templateUrl: "common-quetions.component.html",
                styleUrls: ['common-questions.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ],
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: CommonQuetionsService }, { type: i1$1.FormGroupDirective }]; }, { superTaskTypeCode: [{
            type: Input
        }], isExtension: [{
            type: Input
        }], subTaskDetails: [{
            type: Input
        }] }); })();

class CommonQuetionsModule {
}
CommonQuetionsModule.ɵfac = function CommonQuetionsModule_Factory(t) { return new (t || CommonQuetionsModule)(); };
CommonQuetionsModule.ɵmod = i0.ɵɵdefineNgModule({ type: CommonQuetionsModule });
CommonQuetionsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            ReactiveFormsModule,
            MatSlideToggleModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CommonQuetionsModule, { declarations: [CommonQuestionsComponent], imports: [PrimengLibraryModule,
        ReactiveFormsModule,
        MatSlideToggleModule], exports: [CommonQuestionsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonQuetionsModule, [{
        type: NgModule,
        args: [{
                declarations: [CommonQuestionsComponent],
                imports: [
                    PrimengLibraryModule,
                    ReactiveFormsModule,
                    MatSlideToggleModule
                ],
                exports: [CommonQuestionsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of common-quetions
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CommonQuestionsComponent, CommonQuetionsModule, CommonQuetionsService };
//# sourceMappingURL=common-quetions.js.map
